import React from "react";
import WhyChooseTwo from "../../components/HomeTwo/WhyChooseTwo";


const whyChooseData = {
  // backgroundImage: whyChooseBg,
  phone: "+91 90332 26011",
  title: (
    <>
      Delivering excellence <br />
      every time Express <br />
      Logistics
    </>
  ),
  text: (
    <>
      Construction is an essential industry that involves building <br />
      and designing structures such as buildings, roads, bridges. <br />
      Construction is an essential industry that involves building <br />
      and designing structures such as these.
    </>
  ),
  readMoreLink: "/about",
  sinceYear: "Since 1991",
};

const WhyChoose = () => {
  return (
    <>
      <WhyChooseTwo {...whyChooseData} />
    </>
  );
};

export default WhyChoose;
